// frontend/src/components/projects/LastEvaluationCard.tsx

import { SubmissionSummary } from '../../types/project.types';

function relativeTime(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  const diffDay = Math.floor(diffMs / 86400000);
  if (diffDay === 0) return 'bugün';
  if (diffDay === 1) return '1 gün önce';
  return `${diffDay} gün önce`;
}

interface LastEvaluationCardProps {
  submission: SubmissionSummary;
  projectTitle: string;
}

export function LastEvaluationCard({ submission, projectTitle }: LastEvaluationCardProps) {
  // ai_score 0-100 olarak saklanıyor; 3 ayrı 0-10 boyut görünmüyor (yalnızca
  // genel ortalama kaydedildi) — bu yüzden burada tek bir genel skor gösteriyoruz.
  return (
    <div className="card" style={{ marginTop: 24 }}>
      <h3 className="parent-section-title">🤖 AI Proje Değerlendirmesi</h3>
      <div className="project-eval-header">
        <div className="project-eval-icon">📝</div>
        <div>
          <div className="project-eval-title">Son Değerlendirme: {projectTitle}</div>
          <div className="project-eval-time">{relativeTime(submission.created_at)} • AI Mentor</div>
        </div>
        <div className="project-eval-score">%{submission.ai_score}</div>
      </div>

      {submission.ai_feedback && <p className="project-eval-feedback">{submission.ai_feedback}</p>}

      {submission.ai_improvements.length > 0 && (
        <div className="evaluation-feedback" style={{ marginTop: 16 }}>
          <h4>💡 Geri Bildirim</h4>
          <ul>
            {submission.ai_improvements.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
